import { render, staticRenderFns } from "./ParagraphGroup.vue?vue&type=template&id=546e470a&"
import script from "./ParagraphGroup.vue?vue&type=script&lang=js&"
export * from "./ParagraphGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports